import Alpine from 'alpinejs';
document.addEventListener("alpine:init", () => {
    Alpine.data('accountCollectionEditor', (current_ig_account_id, collection_id, collection_name) => ({
        collection_id: collection_id,
        collections: [],
        currentIgAccountId: current_ig_account_id,
        isSaved: true,
        isSaving: false,
        isAddingCollection: false,
        isCopyingAccounts: false,
        isMovingAccounts: false,
        selectedCollection: null,
        editorMode: 'collected',
        showBulkDropdown: false,
        isEditingName: false,
        hasError: false,
        errorMessage: "",
        isLoading: false,
        collection_name: collection_name,
        bulk_collected_accounts: '',
        modal: {
            show: false,
            new_collection_name: "",
            mode: 'copy',
            step: "existing_collection",
        },
        collected_accounts: {},
        selected_collected_accounts: [],
        query: "",
        status: "ready",
        flashMessage: false,
        flashMessageText: "",
    
        init() {
            if (!this.collection_id || this.collection_id == 'null') {
                this.editorMode = 'edit';
                this.collection_name = 'Untitled Collection';
            } else {
                this.getInitialName();
                this.fetchCollectionData();

                //watch the value of #collection_order and update the order of this.collected_accounts
                document.getElementById('collection_order').addEventListener('change', (e) => {
                    //potential values are: 'name ASC', 'name DESC', 'master_accounts.difficulty_score ASC', 'master_accounts.difficulty_score DESC', 'created_at ASC', 'created_at DESC',
                    let order = e.target.value;
                    let orderField = order.split(' ')[0];
                    let orderDirection = order.split(' ')[1];
                    this.collected_accounts.sort((a, b) => {
                        if( orderField == 'name' ) {
                            if( orderDirection == 'ASC' ) {
                                return a.name.localeCompare(b.name);
                            }else{
                                return b.name.localeCompare(a.name);
                            }
                        }else if( orderField == 'created_at' ) {
                            if( orderDirection == 'ASC' ) {
                                return new Date(a.created_at) - new Date(b.created_at);
                            }else{
                                return new Date(b.created_at) - new Date(a.created_at);
                            }
                        }
                    });
                });
            }


            //prevent 'backspace' key from navigating back
            document.addEventListener('keydown', function(e) {
                if(e.key === 'Backspace' && e.target === document.body) {
                    e.preventDefault();
                }
            });
        },

        async fetchCollectionData() {
            this.isLoading = true;
            try {
                const response = await fetch(`/account_collections/${this.collection_id}/refresh`, {
                    method: 'GET',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) throw new Error("Failed to fetch account data.");

                const data = await response.json();
                this.collections = data.collections;
                this.selectedCollection = this.collections[0].id;
                this.collected_accounts = data.collected_accounts;
                this.status = data.status;

                if ( this.status != "ready" ) {
                    this.startCollectionStatusRefresh();
                } 

                this.hasError = false;
            } catch (error) {
                this.hasError = true;
                this.errorMessage = error.message;
            } finally {
                this.isLoading = false;
            }
        },

        async fetchCollectionAccountData(collected_account_id) {
            try {
                const payload = {
                    collected_account_id: collected_account_id
                };
                const response = await fetch(`/account_collections/${this.collection_id}/refresh_collection_account`, {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });

                if (!response.ok) throw new Error("Failed to fetch account data.");

                const data = await response.json();
                console.log('collected account data:', data);
                //find account in this.collected_accounts and update attributes
                let account = this.collected_accounts.find(account => account.id == collected_account_id);
                if( account ) {
                    account.competitor_id = data.competitor_id;
                    account.username = data.username;
                    account.created_at = data.created_at;
                }
                this.hasError = false;
            } catch (error) {
                this.hasError = true;
                this.errorMessage = error.message;
            }
        },

        async addBulkAccounts() {
            this.isSaving = true;
            const payload = {
                collected_accounts: this.bulk_collected_accounts
            };

            fetch(`/account_collections/${this.collection_id}/add_bulk_collected_accounts`, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })
            .then(response => response.json())
            .then(data => {
                if( data.success ) {
                    this.closeModal();
                    this.bulk_collected_accounts = '';
                    this.isLoading = true;
                    this.isSaving = false;
                    this.showBulkDropdown = false;
                    this.startCollectionStatusRefresh();
                    //remove selected suggested accounts
                    this.selected_collected_accounts = [];
                    this.flashMessage = true;
                    this.flashMessageText = "Bulk accounts are being added to your collection.";
                    setTimeout(() => this.flashMessage = false, 4000);
                }
            })
            .catch(error => {
                console.error("Error copying accounts:", error);
            });
        },

        async copyAccounts() {
            this.isSaving = true;
            const payload = {
                collected_account_ids: this.selected_collected_accounts,
                copy_to_collection: this.selectedCollection
            };

            fetch(`/account_collections/${this.collection_id}/copy_collected_accounts`, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })
            .then(response => response.json())
            .then(data => {
                if( data.success ) {
                    this.closeModal();
                    this.isSaving = false;
                    this.showBulkDropdown = false;
                    this.startCollectionStatusRefresh();
                    //remove selected suggested accounts
                    this.selected_collected_accounts = [];
                    this.flashMessage = true;
                    this.flashMessageText = "Copying selected accounts to another collection.";
                    setTimeout(() => this.flashMessage = false, 4000);
                }
            })
            .catch(error => {
                console.error("Error copying accounts:", error);
            });
        },

        async moveAccounts() {
            this.isSaving = true;
            const payload = {
                collected_account_ids: this.selected_collected_accounts,
                move_to_collection: this.selectedCollection
            };

            fetch(`/account_collections/${this.collection_id}/move_collected_accounts`, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })
            .then(response => response.json())
            .then(data => {
                if( data.success ) {
                    this.closeModal();
                    this.isSaving = false;
                    this.showBulkDropdown = false;
                    this.startCollectionStatusRefresh();
                    //remove selected accounts from list
                    this.collected_accounts = this.collected_accounts.filter(account => {
                        return !this.selected_collected_accounts.includes(account.id);
                    });
                    //remove selected accounts
                    this.selected_collected_accounts = [];
                    this.flashMessage = true;
                    this.flashMessageText = "Moving selected accounts to another collection.";
                    setTimeout(() => this.flashMessage = false, 4000);
                }
            })
            .catch(error => {
                console.error("Error moving accounts:", error);
            });
        },

        async removeAccounts() {
            this.isSaving = true;
            const payload = {
                collected_account_ids: this.selected_collected_accounts
            };

            fetch(`/account_collections/${this.collection_id}/remove_collected_accounts`, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })
            .then(response => response.json())
            .then(data => {
                if( data.success ) {
                    this.isSaving = false;
                    this.showBulkDropdown = false;
                    this.startCollectionStatusRefresh();
                    //remove suggested accounts from list
                    this.collected_accounts = this.collected_accounts.filter(account => {
                        return !this.selected_collected_accounts.includes(account.id);
                    });
                    //remove selected suggested accounts
                    this.selected_collected_accounts = [];
                    this.flashMessage = true;
                    this.flashMessageText = "Removing selected accounts from your collection.";
                    setTimeout(() => this.flashMessage = false, 4000);
                }
            })
            .catch(error => {
                console.error("Error removing accounts:", error);
            });
        },

        startCollectionStatusRefresh() {
            if (this.retryStatusInterval) {
                clearInterval(this.retryStatusInterval);
            }
            this.retryStatusInterval = setInterval(() => {
                fetch(`/account_collections/${this.collection_id}/refresh_status`, {
                    method: "GET",
                    headers: {
                        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
                    }
                })
                .then(response => response.json())
                .then(data => {
                    if (data.status === "ready") {
                        clearInterval(this.retryStatusInterval);
                        this.fetchCollectionData();
                    } else {
                        this.status = data.status;
                    }
                })
                .catch(error => {
                    console.error("Error checking status:", error);
                });
            }, 2000);
        },
    
        changeEditorMode(mode = null){
            if( mode ){
                this.editorMode = mode;
            } else {
                this.editorMode = this.editorMode === 'edit' ? 'view' : 'edit';
            }
        },
    
        getInitialName() {
            let title = document.getElementById('collection_name');
            if (title) {
                this.collection_name = title.value;
            }
        },
        
        saveButtonText() {
            if( this.collection_id == null ) {
                return 'Create'
            }else{
                if (this.isSaving) {
                    return 'Saving...'
                } else if (this.isSaved) {
                    return 'View';
                } else {
                    return 'Save changes';
                }
            }
        },

        toggleCollectedAccountSelection(accountId) {
            accountId = accountId.toString();
            if (this.selected_collected_accounts.includes(accountId)) {
                this.selected_collected_accounts = this.selected_collected_accounts.filter(id => id !== accountId);
            } else {
                this.selected_collected_accounts.push(accountId);
            }
        },
    
        toggleSelectAllCollectedAccounts() {
            if (this.selected_collected_accounts.length === this.collected_accounts.length) {
                // If all contacts are selected, clear selection
                this.selected_collected_accounts = [];
            } else {
                // Otherwise, select all
                let collected_account_ids = this.collected_accounts.map(account => account.id);
                this.selected_collected_accounts = collected_account_ids;
            }
        },
    
        saveCollection() {
            this.isSaving = true;
            let newCollection = true;
            if( this.collection_id != null ) {
                newCollection = false;
            }
        
            // Prepare payload for Rails
            const payload = {
                account_collection: {
                    name: this.collection_name
                }
            };
            
            // Send to Rails backend via AJAX or fetch
            fetch(this.collection_id ? `/account_collections/${this.collection_id}` : "/account_collections", {
                method: this.collection_id ? "PUT" : "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
                },
                body: JSON.stringify(payload)
            })
            .then(response => response.json())
            .then(data => {
                console.log('save data: ', data);
                this.isSaving = false;
                if (!data.id) {
                    throw new Error("Save failed: " + JSON.stringify(data.error));
                }
    
                if (!this.collection_id) {
                    this.collection_id = data.id; // Set caption_id from Rails response
                }
                this.isSaved = true; // Mark as saved
                if( newCollection ) {
                    window.location.href = `/account_collections/${this.collection_id}/`;
                }else{
                    this.changeEditorMode('collected');
                    this.fetchCollectionData();
                }
            })
            .then(response => response.json())
            .catch(error => console.error("Error saving or loading category:", error));
        },

        checkSelectedCollection() {
            if (this.selectedCollection == 0) {
                this.modal.show = true; // Open modal when "Create New Collection" is selected
                this.modal.new_collection_name = ""; // Reset input
                this.modal.step = "new_category";
                this.selectedCollection = null; // Reset selection to prevent accidental submissions
                this.$nextTick(() => document.querySelector("#newCollectionName").focus()); // Focus on input
            }
        },
        
        openModal(mode) {
            if( mode == "bulk_collected_accounts" ){
                this.modal.show = true;
                this.modal.mode = mode;
                this.modal.step = mode;
            }else{
                this.modal.show = true;
                this.modal.mode = mode;
                this.modal.step = "existing_collection";
            }
        },

        closeModal() {
            this.modal.show = false;
            this.modal.new_collection_name = "";
            this.modal.step = "existing_collection";
        },

        modalTitle() {
            if( this.modal.mode == 'copy' ) {
                return "Copy Accounts to Another Collection";
            }else{
                return "Move Accounts to Another Collection";
            }
        },

        async createNewAccountCollection() {
            if (!this.modal.new_collection_name.trim()) {
                alert("Please enter a collection name.");
                return;
            }

            this.isAddingCollection = true;
            try {
                const response = await fetch('/account_collections/new_ajax', {
                    method: 'POST',
                    headers: {
                        'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").getAttribute("content"),
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ 
                        name: this.modal.new_collection_name,
                        ig_account_id: this.currentIgAccountId,
                    })
                });

                if (!response.ok) throw new Error("Failed to create collection.");

                const newCollection = await response.json();
                this.collections.push(newCollection);
                this.collections.sort((a, b) => a.name.localeCompare(b.name));
                this.selectedCollection = newCollection.id;
                this.modal.new_collection_name = "";
                this.isAddingCollection = false;
                this.modal.step = "existing_collection";
            } catch (error) {
                console.error(error);
                alert("Failed to create collection.");
            } finally {
                this.isAddingCollection = false;
            }
        }
    }));
});